import { getUserLocationCookie } from './localStorage';

const getVisitorStateCode = () =>
  getUserLocationCookie()?.stateShortName || null;

export default getVisitorStateCode;
